import { ModalType } from './Modal'

export const getModalTransition = (type?: ModalType) => {
  if (type === 'left-panel')
    return {
      from: { transform: 'translateX(-100%)' },
      enter: { transform: 'translateX(0%)' },
      leave: { transform: 'translateX(-100%)' },
    }

  if (type === 'primary-navbar-more')
    return {
      from: { transform: 'translateX(-90%)' },
      enter: { transform: 'translateX(10%)' },
      leave: { transform: 'translateX(-90%)' },
    }

  if (type === 'right-panel')
    return {
      from: { transform: 'translateX(100%)' },
      enter: { transform: 'translateX(0%)' },
      leave: { transform: 'translateX(100%)' },
    }

  if (type === 'top-panel')
    return {
      from: { transform: 'translateY(-100%)' },
      enter: { transform: 'translateY(0%)' },
      leave: { transform: 'translateY(-100%)' },
    }

  if (type === 'bottom-panel')
    return {
      from: { transform: 'translateY(100%)' },
      enter: { transform: 'translateY(0%)' },
      leave: { transform: 'translateY(100%)' },
    }

  return {
    from: { transform: 'translate3d(-50%, -10%, 0) scale(0.8)', opacity: '0' },
    enter: {
      transform: 'translate3d(-50%, -50%, 0) scale(1)',
      opacity: '1',
      pointerEvents: 'auto',
    },
    leave: {
      transform: 'translate3d(-50%, -50%, 0) scale(0.8)',
      opacity: '0',
      pointerEvents: 'none',
    },
  }
}
